import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const i = a(
  (r, s) => /* @__PURE__ */ o.jsx(
    e,
    {
      ref: s,
      ...r,
      image: (t) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...t,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M8 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7 6H6V4h2a1 1 0 0 1 1 1v8h1v2H6v-2h1z"
            }
          )
        }
      )
    }
  )
);
i.displayName = "InfoIcon";
export {
  i as InfoIcon,
  i as default
};
//# sourceMappingURL=index.js.map
